import { Canvas } from 'fabric';

export function removeAllObjectsForEditor(canvas: Canvas | null) {
  canvas?.off('object:removed');
  canvas?.getObjects().forEach(ob => {
    if (ob.type !== 'image' && ob.type !== 'rect') {
      canvas?.remove(ob);
    }
  });
}
